export default "__VITE_ASSET__71dbb3bf__"